import { useEffect, useRef } from "react";

export const usePrevious = <T>(value: T): T | undefined => {
  const ref = useRef<T>();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};

export function extractFileExtension(filename: string): string {
  return filename.split(".").pop()?.toLowerCase() || "";
}

export function getImageDimensions(
  imgSrc: string,
): Promise<{ width: number; height: number }> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      resolve({ width: img.naturalWidth, height: img.naturalHeight });
    };
    img.onerror = () => {
      URL.revokeObjectURL(imgSrc);
      reject(new Error("Failed to get image dimensions"));
    };
    img.src = imgSrc;
  });
}
